<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>骰子区域配置</span>
          <CommonExport :import-p="'config:sieveArea:import'" :export-p="'config:sieveArea:export'" :get-table="getTables" :type="1" :import-method="importSieveAreaCfg" :export-method="exportSieveAreaCfg" />
          <clear-cache-apply />
          <sync-data />
        </div>

        <el-table
          :data="formData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="area_id"
            label="区域ID"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.area_id" placeholder="区域ID" />
            </template>
          </el-table-column>
          <el-table-column
            prop="lock_num"
            label="解锁数量"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.lock_num" placeholder="解锁数量" />
            </template>
          </el-table-column>
          <el-table-column
            prop="num"
            label="骰子数量"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.num" placeholder="骰子数量" />
            </template>
          </el-table-column>
          <el-table-column
            prop="coin_reward"
            label="奖励"
          >
            <template slot-scope="scope">
              <commonReward v-model="scope.row.reward" />
            </template>
          </el-table-column>
          <el-table-column
            label="骰子配置"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="dialogVisibleArr[scope.$index].visible = true">骰子配置</el-button>
              <el-drawer
                title="提示"
                :visible.sync="dialogVisibleArr[scope.$index].visible"
                size="1000px"
                :before-close="d=>handleClose2(d,scope.$index)"
              >
                <el-form :inline="true">
                  <el-row v-for="(p,i) in scope.row.extra" :key="i" style="margin-top: 8px">
                    <el-form-item label="位置">
                      <el-input v-model.number="p.pos" style="width: 100px;" placeholder="位置" />
                    </el-form-item>
                    <el-form-item label="解锁等级">
                      <el-input v-model.number="p.lockLevel" style="width: 100px;" placeholder="解锁等级" />
                    </el-form-item>
                    <el-form-item label="骰子">
                      <el-form-item>
                        <el-select v-model.number="p.skin" placeholder="请选择" style="width: 120px">
                          <el-option
                            v-for="item in sieve"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </el-form-item>
                    <el-form-item label="道具">
                      <el-select v-model.number="p.prize[0].propsId" placeholder="请选择" style="width: 120px">
                        <el-option
                          v-for="item in rewardType2"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="数量">
                      <el-input v-model.number="p.prize[0].num" style="width: 80px;" placeholder="数量" />
                    </el-form-item>
                    <el-form-item>
                      <el-button v-permisaction="['config:area:add']" size="mini" type="danger" @click="delBeast(scope.$index,i)">删除</el-button>
                    </el-form-item>
                  </el-row>
                  <el-button v-permisaction="['config:area:add']" size="mini" style="margin-top: 5px" type="primary" @click="addBeast(scope.$index)">+</el-button>
                </el-form>
              </el-drawer>
            </template>
          </el-table-column>
        </el-table>

        <el-button v-permisaction="['config:area:add']" style="margin-top: 10px" size="mini" type="primary" @click="add()">+</el-button>
        <el-button v-permisaction="['config:area:add']" style="margin-top: 10px" size="mini" type="primary" @click="onSubmit()">保存</el-button>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { getRewardType } from '@/api/config/slot'
import {
  getSieveAreaCfgList,
  updateSieveAreaCfgCfg, exportSieveAreaCfg, importSieveAreaCfg, getSieveAllList
} from '@/api/config/area-cfg'
import CommonExport from '@/components/CommonExport/index.vue'
import { getRewardListForPropsId } from '@/utils'
import commonReward from '@/components/Reward/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'

export default {
  name: 'SieveArea',
  components: {
    SyncData,
    ClearCacheApply,
    CommonExport,
    commonReward
  },
  data() {
    return {
      dialogVisibleArr: [{ visible: false }],
      langVisibleArr: [{ visible: false }],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      rewardType: [],
      rewardType2: [{ label: '钻石', value: 22 }, { label: '野兽币', value: 65 }],
      formData: [
        {
          'area_id': 0,
          'lock_num': 0,
          'num': 0,
          'extra': [],
          'reward': [{ propsId: 1, num: 1, skin: 1, rtype: 1 }]
        }
      ],
      skinId: [62, 19, 67, 68],
      chessId: [],
      shield: [],
      sieve: [],
      areaId: [] }
  },
  created() {
    this.getSieveConfig()
    this.getTables()
    this.getRewardTypeData()
  },
  methods: {
    getSieveConfig() {
      getSieveAllList().then(res => {
        for (const i in res.data) {
          this.sieve.push({ label: res.data[i].lang_key, value: parseInt(res.data[i].id) })
        }
      })
    },
    exportSieveAreaCfg,
    importSieveAreaCfg,
    handleClose(d, index) {
      this.langVisibleArr[index].visible = false
    },
    handleClose2(d, index) {
      this.dialogVisibleArr[index].visible = false
    },
    onSubmit() {
      // let data = []
      // this.formData.forEach((item) => {
      //   item.reward_num = parseFloat(item.reward_num)
      //   data.push(item)
      // })
      for (const i in this.formData) {
        const val = this.formData[i]
        for (const k in val.extra) {
          const extra = val.extra[k]
          if (extra.pos <= 0) {
            this.msgError('位置不能为0')
            return
          }
          if (extra.skin <= 0) {
            this.msgError('请选择皮肤')
            return
          }
        }
      }
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateSieveAreaCfgCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getSieveAreaCfgList(this.queryParams).then(res => {
        this.formData = res.data.list
        res.data.list.forEach((item, index) => {
          this.langVisibleArr.push({
            visible: false
          })
          this.dialogVisibleArr.push({
            visible: false
          })
        })
        this.total = res.data.count
      })
    },
    add() {
      this.formData.push({
        'area_id': 0,
        'lock_num': 0,
        // 'pos': 0,
        // 'beast_id': 0,
        // 'prize': [{ propsId: 22, num: 1, skin: 0, rtype: 0 }],
        'num': 0,
        'reward': [],
        'extra': []
      })
      this.langVisibleArr.push({ visible: false })
      this.dialogVisibleArr.push({ visible: false })
    },
    addReward(index) {
      this.formData[index].reward.push({ propsId: 1, num: 1, skin: 1, rtype: 1 })
    },
    removeReward(index, zIndex) {
      this.formData[index].reward = this.formData[index].reward.filter((item, i) => {
        return i !== zIndex
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    changeProp(v, index, i) {
      this.formData[index].reward[i].skin = v
    },
    getRewardList(prize) {
      return getRewardListForPropsId(prize, this.rewardType)
    },
    addBeast(index) {
      if (this.formData[index].extra == null) {
        this.formData[index].extra = []
      }
      this.formData[index].extra.push({ pos: 0, skin: 0, lockLevel: 0, prize: [{ propsId: 22, num: 1, skin: 0, rtype: 0 }] })
    },
    delBeast(index, i) {
      this.formData[index].extra = this.formData[index].extra.filter((item, idx) => {
        return i !== idx
      })
    }
  }
}
</script>

<style scoped>
</style>
